import request from '@/utils/request'

export function updateRouletteCfg(data) {
  return request({
    url: 'api/v1/roulette/updateCfg',
    method: 'post',
    data: data
  })
}

export function getRouletteCfgList(data) {
  return request({
    url: 'api/v1/roulette/getList',
    method: 'post',
    data: data
  })
}

export function delRouletteCfgList(data) {
  return request({
    url: 'api/v1/roulette/deleteCfg',
    method: 'delete',
    data: data
  })
}
